import React from 'react'
import TestimonialCards from './TestimonialCards'

const Testimonials = () => {
  return (
    <div>
      <TestimonialCards/>
    </div>
  )
}

export default Testimonials